module.exports = __webpack_public_path__ + "img/30_7.d6c2a702.png";